// extracted by mini-css-extract-plugin
module.exports = {"regis-info":"baseInfo_regis-info__uL-6G"};